export default __webpack_public_path__ + "static/media/instructor-tutor-bg.6a48fd11.jpg";